module.exports = __webpack_public_path__ + "078428471c8119d9fdba084c948a8aa3.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/RamonaRamon_in_Athen.jpg
// module id = 890
// module chunks = 0